var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from 'primereact/checkbox';
import { apiService } from '../utils/api';
import { formatDateForBackend } from '../utils/dateUtils';
import { formatINR } from '../utils/currencyUtils';
import MdlPaginatorLeft from '../components/MdlPaginatorLeft';
import '../styles/masterListView.css';
var LoanDisbursement = function () {
    var _a = useState([]), villages = _a[0], setVillages = _a[1];
    var _b = useState([]), sangams = _b[0], setSangams = _b[1];
    var _c = useState([]), loanTypes = _c[0], setLoanTypes = _c[1];
    var _d = useState([]), banks = _d[0], setBanks = _d[1];
    var _e = useState(null), selectedVillage = _e[0], setSelectedVillage = _e[1];
    var _f = useState(null), selectedSangam = _f[0], setSelectedSangam = _f[1];
    var _g = useState(null), selectedBank = _g[0], setSelectedBank = _g[1];
    // Common styles for input fields
    var commonInputStyle = { width: 220 };
    var _h = useState(0), pageFirst = _h[0], setPageFirst = _h[1];
    var _j = useState(12), pageRows = _j[0], setPageRows = _j[1];
    var _k = useState(''), chequeNumber = _k[0], setChequeNumber = _k[1];
    var _l = useState(null), disbursementDate = _l[0], setDisbursementDate = _l[1];
    var _m = useState(null), sanctionAmount = _m[0], setSanctionAmount = _m[1];
    var _o = useState(null), term = _o[0], setTerm = _o[1];
    var _p = useState(null), selectedLoanType = _p[0], setSelectedLoanType = _p[1];
    var _q = useState([]), rows = _q[0], setRows = _q[1];
    var _r = useState(false), selectAll = _r[0], setSelectAll = _r[1];
    var _s = useState(false), isTamil = _s[0], setIsTamil = _s[1];
    var toast = useRef(null);
    var formatIndianRupees = formatINR;
    // Fetch data on component mount
    useEffect(function () {
        fetchVillages();
        fetchSangams();
        fetchLoanTypes();
        fetchBanks();
    }, []);
    // Reset sangam when village changes
    useEffect(function () {
        setSelectedSangam(null);
        setRows([]);
    }, [selectedVillage]);
    // Fetch members when sangam changes
    useEffect(function () {
        if (selectedSangam) {
            fetchMembers(selectedSangam);
        }
        else {
            setRows([]);
        }
    }, [selectedSangam]);
    // Update loan amounts when sanction amount or selected members change
    useEffect(function () {
        updateLoanAmounts();
    }, [sanctionAmount, selectAll]);
    var fetchVillages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/villages')];
                case 1:
                    response = _c.sent();
                    if (response.success) {
                        setVillages(response.data || []);
                    }
                    else {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: response.error || 'Failed to fetch villages'
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    console.error('Error fetching villages:', error_1);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to fetch villages'
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchSangams = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/sangams')];
                case 1:
                    response = _c.sent();
                    if (response.success) {
                        setSangams(response.data || []);
                    }
                    else {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: response.error || 'Failed to fetch sangams'
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _c.sent();
                    console.error('Error fetching sangams:', error_2);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to fetch sangams'
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchLoanTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, mockLoanTypes, error_3, mockLoanTypes;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get('/loans/types')];
                case 1:
                    response = _b.sent();
                    if (response.success) {
                        setLoanTypes(response.data || []);
                    }
                    else {
                        console.error('Failed to fetch loan types:', response.error);
                        mockLoanTypes = [
                            { id: 1, name: 'Education Loan', nameTamil: 'கல்வி கடன்' },
                            { id: 2, name: 'Business Loan', nameTamil: 'தொழில் கடன்' },
                            { id: 3, name: 'Marriage Loan', nameTamil: 'திருமண கடன்' },
                            { id: 4, name: 'Emergency Loan', nameTamil: 'அவசர கடன்' },
                            { id: 5, name: 'Agriculture Loan', nameTamil: 'விவசாய கடன்' }
                        ];
                        setLoanTypes(mockLoanTypes);
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                            severity: 'warn',
                            summary: 'Warning',
                            detail: 'Using mock loan types. API endpoint may not be available.'
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _b.sent();
                    console.error('Error fetching loan types:', error_3);
                    mockLoanTypes = [
                        { id: 1, name: 'Education Loan', nameTamil: 'கல்வி கடன்' },
                        { id: 2, name: 'Business Loan', nameTamil: 'தொழில் கடன்' },
                        { id: 3, name: 'Marriage Loan', nameTamil: 'திருமண கடன்' },
                        { id: 4, name: 'Emergency Loan', nameTamil: 'அவசர கடன்' },
                        { id: 5, name: 'Agriculture Loan', nameTamil: 'விவசாய கடன்' }
                    ];
                    setLoanTypes(mockLoanTypes);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchBanks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, mockBanks, error_4, mockBanks;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    console.log('Fetching banks from API...');
                    return [4 /*yield*/, apiService.get('/banks')];
                case 1:
                    response = _c.sent();
                    console.log('Banks API response:', response);
                    if (response.success) {
                        console.log('Banks data:', response.data);
                        setBanks(response.data || []);
                    }
                    else {
                        console.error('Failed to fetch banks:', response.error);
                        mockBanks = [
                            { id: 1, bankName: 'State Bank of India', accountNo: '123456789', branch: 'Main Branch', ifsc: 'SBIN0001234', createdAt: '', updatedAt: '', createdBy: 1, modifiedBy: 1, isDeleted: false },
                            { id: 2, bankName: 'HDFC Bank', accountNo: '987654321', branch: 'Main Branch', ifsc: 'HDFC0001234', createdAt: '', updatedAt: '', createdBy: 1, modifiedBy: 1, isDeleted: false },
                            { id: 3, bankName: 'ICICI Bank', accountNo: '456789123', branch: 'Main Branch', ifsc: 'ICIC0001234', createdAt: '', updatedAt: '', createdBy: 1, modifiedBy: 1, isDeleted: false }
                        ];
                        setBanks(mockBanks);
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                            severity: 'warn',
                            summary: 'Warning',
                            detail: 'Using mock bank data. API endpoint may not be available.'
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _c.sent();
                    console.error('Error fetching banks:', error_4);
                    mockBanks = [
                        { id: 1, bankName: 'State Bank of India', accountNo: '123456789', branch: 'Main Branch', ifsc: 'SBIN0001234', createdAt: '', updatedAt: '', createdBy: 1, modifiedBy: 1, isDeleted: false },
                        { id: 2, bankName: 'HDFC Bank', accountNo: '987654321', branch: 'Main Branch', ifsc: 'HDFC0001234', createdAt: '', updatedAt: '', createdBy: 1, modifiedBy: 1, isDeleted: false },
                        { id: 3, bankName: 'ICICI Bank', accountNo: '456789123', branch: 'Main Branch', ifsc: 'ICIC0001234', createdAt: '', updatedAt: '', createdBy: 1, modifiedBy: 1, isDeleted: false }
                    ];
                    setBanks(mockBanks);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({
                        severity: 'warn',
                        summary: 'Warning',
                        detail: 'Using mock bank data. Please check API connection.'
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var fetchMembers = function (sangamId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, members, newRows, error_5;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, apiService.get("/members/by-sangam/".concat(sangamId))];
                case 1:
                    response = _c.sent();
                    if (response.success) {
                        members = response.data || [];
                        newRows = members.map(function (member) { return ({
                            memberId: member.id,
                            cpdNo: member.cpdNo || "CPD".concat(member.id.toString().padStart(3, '0')),
                            memberName: isTamil ? (member.nameTamil || member.name) : member.name,
                            loanAmount: 0,
                            selected: false
                        }); });
                        setRows(newRows);
                    }
                    else {
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: response.error || 'Failed to fetch members'
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_5 = _c.sent();
                    console.error('Error fetching members:', error_5);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to fetch members'
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateLoanAmounts = function () {
        setRows(function (prev) {
            var selectedRows = prev.filter(function (row) { return row.selected; });
            var selectedCount = selectedRows.length;
            if (selectedCount === 0 || !sanctionAmount || sanctionAmount === 0) {
                return prev.map(function (row) { return (__assign(__assign({}, row), { loanAmount: 0 })); });
            }
            // Auto-adjust amounts equally among selected members
            var loanAmountPerMember = Math.floor(sanctionAmount / selectedCount);
            var remainder = sanctionAmount % selectedCount;
            var remainderDistributed = 0;
            return prev.map(function (row) {
                if (row.selected) {
                    var additionalAmount = remainderDistributed < remainder ? 1 : 0;
                    remainderDistributed++;
                    return __assign(__assign({}, row), { loanAmount: loanAmountPerMember + additionalAmount });
                }
                else {
                    return __assign(__assign({}, row), { loanAmount: 0 });
                }
            });
        });
    };
    var handleLoanAmountChange = function (rowIndex, newAmount) {
        setRows(function (prev) {
            var _a;
            var updated = __spreadArray([], prev, true);
            updated[rowIndex] = __assign(__assign({}, updated[rowIndex]), { loanAmount: newAmount || 0 });
            // Get all selected rows
            var selectedRows = updated.filter(function (row) { return row.selected; });
            var selectedCount = selectedRows.length;
            if (selectedCount <= 1 || !sanctionAmount || sanctionAmount === 0) {
                return updated;
            }
            // Calculate remaining amount to distribute among other selected members
            var currentMemberAmount = updated[rowIndex].loanAmount;
            var remainingAmount = sanctionAmount - currentMemberAmount;
            var otherSelectedCount = selectedCount - 1;
            if (otherSelectedCount > 0 && remainingAmount >= 0) {
                // Distribute remaining amount equally among other selected members
                var amountPerOtherMember_1 = Math.floor(remainingAmount / otherSelectedCount);
                var remainder_1 = remainingAmount % otherSelectedCount;
                var remainderDistributed_1 = 0;
                return updated.map(function (row, index) {
                    if (row.selected && index !== rowIndex) {
                        var additionalAmount = remainderDistributed_1 < remainder_1 ? 1 : 0;
                        remainderDistributed_1++;
                        return __assign(__assign({}, row), { loanAmount: amountPerOtherMember_1 + additionalAmount });
                    }
                    return row;
                });
            }
            // Show warning if total would exceed sanction amount
            var totalDisbursement = updated
                .filter(function (row) { return row.selected; })
                .reduce(function (sum, row) { return sum + row.loanAmount; }, 0);
            if (totalDisbursement > sanctionAmount) {
                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                    severity: 'warn',
                    summary: 'Amount Exceeded',
                    detail: "Total disbursement (".concat(formatIndianRupees(totalDisbursement), ") exceeds sanction amount (").concat(formatIndianRupees(sanctionAmount), ")")
                });
            }
            return updated;
        });
    };
    var handleSelectAll = function (checked) {
        setSelectAll(checked);
        setRows(function (prev) {
            var updated = prev.map(function (row) { return (__assign(__assign({}, row), { selected: checked })); });
            // Auto-adjust loan amounts after selection change
            if (sanctionAmount && sanctionAmount > 0) {
                var selectedCount_1 = checked ? updated.length : 0;
                if (selectedCount_1 === 0) {
                    return updated.map(function (row) { return (__assign(__assign({}, row), { loanAmount: 0 })); });
                }
                var loanAmountPerMember_1 = Math.floor(sanctionAmount / selectedCount_1);
                var remainder_2 = sanctionAmount % selectedCount_1;
                var remainderDistributed_2 = 0;
                return updated.map(function (row) {
                    if (row.selected) {
                        var additionalAmount = remainderDistributed_2 < remainder_2 ? 1 : 0;
                        remainderDistributed_2++;
                        return __assign(__assign({}, row), { loanAmount: loanAmountPerMember_1 + additionalAmount });
                    }
                    else {
                        return __assign(__assign({}, row), { loanAmount: 0 });
                    }
                });
            }
            return updated;
        });
    };
    var handleRowSelect = function (rowIndex, checked) {
        setRows(function (prev) {
            var updated = __spreadArray([], prev, true);
            updated[rowIndex] = __assign(__assign({}, updated[rowIndex]), { selected: checked });
            // Update select all checkbox
            var allSelected = updated.every(function (row) { return row.selected; });
            setSelectAll(allSelected);
            // Auto-adjust loan amounts after selection change
            if (sanctionAmount && sanctionAmount > 0) {
                var selectedRows = updated.filter(function (row) { return row.selected; });
                var selectedCount_2 = selectedRows.length;
                if (selectedCount_2 === 0) {
                    return updated.map(function (row) { return (__assign(__assign({}, row), { loanAmount: 0 })); });
                }
                var loanAmountPerMember_2 = Math.floor(sanctionAmount / selectedCount_2);
                var remainder_3 = sanctionAmount % selectedCount_2;
                var remainderDistributed_3 = 0;
                return updated.map(function (row) {
                    if (row.selected) {
                        var additionalAmount = remainderDistributed_3 < remainder_3 ? 1 : 0;
                        remainderDistributed_3++;
                        return __assign(__assign({}, row), { loanAmount: loanAmountPerMember_2 + additionalAmount });
                    }
                    else {
                        return __assign(__assign({}, row), { loanAmount: 0 });
                    }
                });
            }
            return updated;
        });
    };
    // Update loan amounts when individual rows are selected/deselected
    useEffect(function () {
        updateLoanAmounts();
    }, [rows.map(function (r) { return r.selected; }).join(',')]);
    var validateForm = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!selectedVillage) {
            (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please select a village'
            });
            return false;
        }
        if (!selectedSangam) {
            (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please select a sangam'
            });
            return false;
        }
        if (!selectedBank) {
            (_c = toast.current) === null || _c === void 0 ? void 0 : _c.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please select a bank'
            });
            return false;
        }
        if (!chequeNumber.trim()) {
            (_d = toast.current) === null || _d === void 0 ? void 0 : _d.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please enter cheque number'
            });
            return false;
        }
        if (!disbursementDate) {
            (_e = toast.current) === null || _e === void 0 ? void 0 : _e.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please select disbursement date'
            });
            return false;
        }
        if (!selectedLoanType) {
            (_f = toast.current) === null || _f === void 0 ? void 0 : _f.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please select loan type'
            });
            return false;
        }
        if (!sanctionAmount || sanctionAmount <= 0) {
            (_g = toast.current) === null || _g === void 0 ? void 0 : _g.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please enter a valid sanction amount'
            });
            return false;
        }
        if (!term || term <= 0) {
            (_h = toast.current) === null || _h === void 0 ? void 0 : _h.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please enter a valid term (months)'
            });
            return false;
        }
        var selectedRows = rows.filter(function (row) { return row.selected; });
        if (selectedRows.length === 0) {
            (_j = toast.current) === null || _j === void 0 ? void 0 : _j.show({
                severity: 'warn',
                summary: 'No Selection',
                detail: 'Please select at least one member for loan disbursement'
            });
            return false;
        }
        return true;
    };
    var handleLoanDisbursement = function () {
        if (!validateForm()) {
            return;
        }
        var selectedRows = rows.filter(function (row) { return row.selected; });
        var totalDisbursementAmount = selectedRows.reduce(function (sum, row) { return sum + row.loanAmount; }, 0);
        confirmDialog({
            message: "Are you sure you want to process loan disbursement for ".concat(selectedRows.length, " members with total amount ").concat(formatIndianRupees(totalDisbursementAmount), "?"),
            header: 'Confirm Loan Disbursement',
            icon: 'pi pi-exclamation-triangle',
            accept: function () { return processLoanDisbursement(); },
            reject: function () {
                var _a;
                (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                    severity: 'info',
                    summary: 'Cancelled',
                    detail: 'Loan disbursement cancelled'
                });
            }
        });
    };
    var processLoanDisbursement = function () { return __awaiter(void 0, void 0, void 0, function () {
        var selectedRows, selectedBankData, requestData, response, responseData, error_6;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    selectedRows = rows.filter(function (row) { return row.selected; });
                    selectedBankData = banks.find(function (b) { return b.id === selectedBank; });
                    requestData = {
                        villageId: selectedVillage,
                        sangamId: selectedSangam,
                        bankId: selectedBank,
                        bankName: selectedBankData ? selectedBankData.bankName : '',
                        chequeNumber: chequeNumber,
                        disbursementDate: formatDateForBackend(disbursementDate),
                        sanctionAmount: sanctionAmount,
                        term: term,
                        loanTypeId: selectedLoanType,
                        memberLoans: selectedRows.map(function (row) { return ({
                            memberId: row.memberId,
                            cpdNo: row.cpdNo,
                            memberName: row.memberName,
                            loanAmount: row.loanAmount
                        }); })
                    };
                    return [4 /*yield*/, apiService.post('/loans/disburse', requestData)];
                case 1:
                    response = _c.sent();
                    if (response.success) {
                        responseData = response.data;
                        (_a = toast.current) === null || _a === void 0 ? void 0 : _a.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: "".concat(responseData.message, ". Bill No: ").concat(responseData.billNo)
                        });
                    }
                    else {
                        throw new Error(response.error || 'Failed to process loan disbursement');
                    }
                    // Reset form after successful processing
                    resetForm();
                    return [3 /*break*/, 3];
                case 2:
                    error_6 = _c.sent();
                    console.error('Error processing loan disbursement:', error_6);
                    (_b = toast.current) === null || _b === void 0 ? void 0 : _b.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to process loan disbursement'
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var resetForm = function () {
        setSelectedVillage(null);
        setSelectedSangam(null);
        setSelectedBank(null);
        setChequeNumber('');
        setDisbursementDate(null);
        setSanctionAmount(null);
        setTerm(null);
        setSelectedLoanType(null);
        setRows([]);
        setSelectAll(false);
    };
    // Calculate totals
    var selectedCount = rows.filter(function (row) { return row.selected; }).length;
    var totalDisbursementAmount = rows
        .filter(function (row) { return row.selected; })
        .reduce(function (sum, row) { return sum + row.loanAmount; }, 0);
    // Add custom CSS for styling
    useEffect(function () {
        var style = document.createElement('style');
        style.textContent = "\n      .loan-disbursement-container .p-datatable .p-datatable-tbody > tr:hover {\n        background-color: #f8f9fa !important;\n      }\n      .loan-disbursement-container .p-checkbox .p-checkbox-box.p-highlight {\n        background-color: #1A237E !important;\n        border-color: #1A237E !important;\n      }\n    ";
        document.head.appendChild(style);
        return function () {
            if (document.head.contains(style)) {
                document.head.removeChild(style);
            }
        };
    }, []);
    return (_jsxs("div", __assign({ className: "card mdl-page loan-disbursement-container" }, { children: [_jsx(Toast, { ref: toast }), _jsxs("div", __assign({ className: "mdl-page-header" }, { children: [_jsxs("div", { children: [_jsx("h1", __assign({ className: "mdl-page-title" }, { children: "Loan Disbursement" })), _jsx("p", __assign({ className: "mdl-page-subtitle" }, { children: rows.length === 0 ? 'Select a village and sangam to load members' : "".concat(rows.length, " members \u00B7 ").concat(selectedCount, " selected") }))] }), _jsxs("div", __assign({ className: "mdl-page-actions" }, { children: [_jsx(Button, { label: isTamil ? "English" : "தமிழ்", icon: isTamil ? "pi pi-globe" : "pi pi-language", onClick: function () { return setIsTamil(!isTamil); }, className: "mdl-btn-outline" }), _jsx(Button, { label: "Process Disbursement", icon: "pi pi-check", onClick: handleLoanDisbursement, className: "mdl-btn-primary" })] }))] })), _jsxs("div", __assign({ className: "mdl-form-bar" }, { children: [_jsxs("div", __assign({ className: "mdl-form-row" }, { children: [_jsx(Dropdown, { value: selectedVillage, options: villages.map(function (v) { return ({
                                    label: isTamil ? (v.nameTamil || v.name) : v.name,
                                    value: v.id
                                }); }), onChange: function (e) { return setSelectedVillage(e.value); }, optionLabel: "label", optionValue: "value", placeholder: isTamil ? "கிராமம்" : "Village", style: commonInputStyle, className: "p-inputtext-sm" }), _jsx(Dropdown, { value: selectedSangam, options: sangams
                                    .filter(function (s) { var _a; return ((_a = s.village) === null || _a === void 0 ? void 0 : _a.id) === selectedVillage || s.villageId === selectedVillage; })
                                    .map(function (s) { return ({ label: s.name || "Sangam ".concat(s.sangamNo), value: s.id }); }), onChange: function (e) { return setSelectedSangam(e.value); }, optionLabel: "label", optionValue: "value", placeholder: isTamil ? "சங்கம்" : "Sangam", style: commonInputStyle, className: "p-inputtext-sm", disabled: !selectedVillage }), _jsx(Dropdown, { value: selectedLoanType, options: loanTypes.map(function (lt) { return ({
                                    label: isTamil ? (lt.nameTamil || lt.name) : lt.name,
                                    value: lt.id
                                }); }), onChange: function (e) { return setSelectedLoanType(e.value); }, optionLabel: "label", optionValue: "value", placeholder: isTamil ? "கடன் வகை" : "Loan Type", style: commonInputStyle, className: "p-inputtext-sm" }), _jsx(InputNumber, { value: sanctionAmount, onValueChange: function (e) { return setSanctionAmount(e.value || null); }, placeholder: isTamil ? "தொகை" : "Amount", mode: "currency", currency: "INR", locale: "en-IN", style: commonInputStyle, className: "p-inputtext-sm", showButtons: false }), _jsx(InputNumber, { value: term, onValueChange: function (e) { return setTerm(e.value || null); }, placeholder: isTamil ? "மாதம்" : "Months", style: commonInputStyle, className: "p-inputtext-sm", min: 1, max: 120, showButtons: false })] })), _jsx("div", { className: "mdl-form-divider" }), _jsxs("div", __assign({ className: "mdl-form-row" }, { children: [_jsx(Dropdown, { value: selectedBank, options: banks.map(function (b) { return ({
                                    label: b.bankName,
                                    value: b.id
                                }); }), onChange: function (e) { return setSelectedBank(e.value); }, optionLabel: "label", optionValue: "value", placeholder: isTamil ? "வங்கி பெயர்" : "Bank Name", style: commonInputStyle, className: "p-inputtext-sm", emptyMessage: "No banks available", showClear: true }), _jsx(InputText, { value: chequeNumber, onChange: function (e) { return setChequeNumber(e.target.value); }, placeholder: isTamil ? "காசோலை எண்" : "Cheque Number", style: commonInputStyle, className: "p-inputtext-sm" }), _jsx(Calendar, { value: disbursementDate, onChange: function (e) { return setDisbursementDate(e.value); }, dateFormat: "dd/mm/yy", placeholder: isTamil ? "வழங்கும் தேதி" : "Disbursement Date", style: commonInputStyle, className: "p-inputtext-sm" })] }))] })), _jsxs(DataTable, __assign({ value: rows, className: "p-datatable-sm mdl-table-header mdl-table-footer", style: { minWidth: 600 }, paginator: true, first: pageFirst, rows: pageRows, onPage: function (e) { setPageFirst(e.first); setPageRows(e.rows); }, paginatorLeft: _jsx(MdlPaginatorLeft, { id: "loan-disb-rows-per-page", first: pageFirst, rows: pageRows, total: rows.length, onRowsChange: function (r) { setPageRows(r); setPageFirst(0); } }), paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink", scrollable: true, scrollHeight: "400px", emptyMessage: "Select a village and sangam to load members", header: _jsxs("div", __assign({ className: "mdl-table-caption" }, { children: [_jsxs("label", __assign({ className: "mdl-table-caption-check" }, { children: [_jsx(Checkbox, { inputId: "selectAll", checked: selectAll, onChange: function (e) { var _a; return handleSelectAll((_a = e.checked) !== null && _a !== void 0 ? _a : false); } }), _jsx("span", { children: isTamil ? 'அனைத்தையும் தேர்ந்தெடு' : 'Select All' })] })), _jsx("span", { children: isTamil ? "\u0BAE\u0BCA\u0BA4\u0BCD\u0BA4 \u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0BA9\u0BB0\u0BCD\u0B95\u0BB3\u0BCD: ".concat(rows.length) : "Total Members: ".concat(rows.length) })] })) }, { children: [_jsx(Column, { header: isTamil ? 'வ.எண்' : 'SN', body: function (data, options) { return options.rowIndex + 1; }, headerClassName: "mdl-col-numeric", bodyClassName: "mdl-col-numeric", style: { width: '60px' } }), _jsx(Column, { field: "cpdNo", header: isTamil ? 'CPD எண்' : 'CPD No', style: { width: '100px' } }), _jsx(Column, { field: "memberName", header: isTamil ? 'உறுப்பினர் பெயர்' : 'Member Name', body: function (r) { return _jsx("span", __assign({ className: "mdl-name-cell" }, { children: r.memberName })); }, style: { width: '200px' } }), _jsx(Column, { field: "loanAmount", header: isTamil ? 'கடன் தொகை' : 'Loan Amount', body: function (rowData, options) { return (_jsx(InputNumber, { value: rowData.loanAmount, onValueChange: function (e) { return handleLoanAmountChange(options.rowIndex, e.value || 0); }, mode: "currency", currency: "INR", locale: "en-IN", disabled: !rowData.selected, style: {
                                width: '120px',
                                opacity: rowData.selected ? 1 : 0.6
                            }, className: "p-inputtext-sm", min: 0, max: sanctionAmount || undefined })); }, style: { width: '140px', textAlign: 'center' } }), _jsx(Column, { header: isTamil ? 'தேர்வு' : 'Select', body: function (rowData, options) { return (_jsx(Checkbox, { checked: rowData.selected, onChange: function (e) { var _a; return handleRowSelect(options.rowIndex, (_a = e.checked) !== null && _a !== void 0 ? _a : false); } })); }, style: { width: '80px', textAlign: 'center' } })] })), _jsxs("div", __assign({ className: "mdl-summary-bar" }, { children: [_jsxs("div", __assign({ className: "mdl-summary-chips" }, { children: [_jsx("span", __assign({ className: "mdl-chip success" }, { children: isTamil ? "\u0BA4\u0BC7\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BC6\u0B9F\u0BC1\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F \u0B89\u0BB1\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0BA9\u0BB0\u0BCD\u0B95\u0BB3\u0BCD: ".concat(selectedCount) : "Selected Members: ".concat(selectedCount) })), _jsxs("span", __assign({ className: "mdl-chip" }, { children: [isTamil ? 'அனுமதி தொகை' : 'Sanction Amount', ": ", formatIndianRupees(sanctionAmount)] }))] })), _jsxs("span", __assign({ className: "mdl-total-box".concat(sanctionAmount && totalDisbursementAmount > sanctionAmount ? ' over' : '') }, { children: [isTamil ? 'மொத்த வழங்கும் தொகை' : 'Total Disbursement', ": ", formatIndianRupees(totalDisbursementAmount), sanctionAmount && totalDisbursementAmount > sanctionAmount && (_jsx("i", { className: "pi pi-exclamation-triangle" }))] }))] }))] })));
};
export default LoanDisbursement;
